import InfoIcon from "@/assets/svgs/info.svg";
import { Link } from "@/components/shared/inputs/link/link";
import type { WorkPurchasedMessage as WorkPurchasedMessageData } from "@/types/work.types";
import styles from "./work-purchased-message.module.scss";
import { legacyUrlString } from "@/utility/url";

interface WorkPurchasedMessageProps {
  message: WorkPurchasedMessageData;
  idWork: number;
  cleanUrl: string;
}

/**
 * Shows a signed-in customer's most recent purchase of the current work and
 * links to the corresponding order and review action.
 * @param root0 Component properties.
 * @param root0.message Server-provided purchase date, order, and review state.
 * @param root0.idWork Current work identifier used by the review URL.
 * @param root0.cleanUrl Current work slug used by the review URL.
 * @returns The previously-purchased message.
 */
const WorkPurchasedMessage = ({
  message,
  idWork,
  cleanUrl,
}: WorkPurchasedMessageProps) => {
  const orderDetailsUrl = `/account/orderdetails?ordr=${encodeURIComponent(message.orderNumber)}`;
  const reviewUrl = legacyUrlString(`/w/${cleanUrl}/${idWork}/review/`);

  return (
    <aside className={styles.root} aria-label="Previous purchase">
      <InfoIcon className={styles.icon} aria-hidden />
      <div className={styles.message}>
        <div>You purchased this item on {message.datePurchased}.</div>
        <div>
          <Link href={orderDetailsUrl} linkType="legacy" underline="always">
            Order Details
          </Link>
          <span className={styles.divider} aria-hidden="true">
            |
          </span>
          <Link href={reviewUrl} linkType="legacy" underline="always">
            {message.didWriteReview ? "Edit your review" : "Write a review"}
          </Link>
        </div>
      </div>
    </aside>
  );
};

export default WorkPurchasedMessage;
